import { render, staticRenderFns } from "./im-tip.vue?vue&type=template&id=1d1d5c23"
import script from "./im-tip.vue?vue&type=script&lang=js"
export * from "./im-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1d5c23')) {
      api.createRecord('1d1d5c23', component.options)
    } else {
      api.reload('1d1d5c23', component.options)
    }
    module.hot.accept("./im-tip.vue?vue&type=template&id=1d1d5c23", function () {
      api.rerender('1d1d5c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/component/im-tip.vue"
export default component.exports